import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=a5e3ce60&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"
import style0 from "./Submit.vue?vue&type=style&index=0&id=a5e3ce60&scoped=true&lang=css&"
import style1 from "./Submit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e3ce60",
  null
  
)

export default component.exports